import React from 'react';
import { motion } from 'framer-motion';
import { useOS } from './OSContext';
import apps from './apps';

const dockApps = apps.filter((a) => a.showInDock);

const Dock = () => {
  const { openApp, windows, activeId } = useOS();

  return (
    <div className="fixed bottom-2 left-1/2 -translate-x-1/2 z-40 flex items-end gap-2 px-3 py-2 bg-os-chrome/70 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl">
      {dockApps.map((app) => {
        const isOpen = Boolean(windows[app.id]);
        const isActive = activeId === app.id;

        return (
          <motion.button
            key={app.id}
            type="button"
            onClick={() => openApp(app)}
            whileHover={{ scale: 1.15, y: -6 }}
            whileTap={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 400, damping: 15 }}
            className="relative flex flex-col items-center focus:outline-none"
            title={app.title}
          >
            <span
              className={`flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-xl border border-white/10 shadow-lg text-os-text text-xl sm:text-2xl bg-os-surface2/90 ${
                isActive ? 'ring-2 ring-os-accent/70' : ''
              }`}
            >
              <i className={app.icon} aria-hidden="true" />
            </span>
            <span
              className={`mt-1 w-1 h-1 rounded-full bg-white transition-opacity ${
                isOpen ? 'opacity-100' : 'opacity-0'
              }`}
            />
          </motion.button>
        );
      })}
    </div>
  );
};

export default Dock;
